import { WorkflowOperator, WorkflowDestination } from ".";

// ワークフロー実施情報model
export class WorkflowOperation {

  // 実施者
  public operator: WorkflowOperator;
  // 処理名
  public operationName: string;
  // 実施日時
  public operationDateTime: Date;
  // 伝達事項
  public nextMessage: string;
  // 差戻し先
  public destination: WorkflowDestination;
}
